export function filterDefinedValues(obj) {
    const result = {};

    Object.keys(obj).forEach((key) => {
        const value = obj[key];

        if (!!value && value !== "null" && value !== "undefined") {
            result[key] = obj[key];
        }
    });

    return result;
}